import { Text } from '@thanx/uikit/text'

import type { UidGroupRow } from 'api/canonicalPicker.types'

import PickerRowLabel from './PickerRowLabel'

type Props = {
  /** What sets these apart: "Not under this item", "Not on these items" */
  label: string
  groups: UidGroupRow[]
}

/**
 * Searched UIDs that exist in the catalog but outside what level 1 picked:
 * listed so they are never silently missing, and never pickable here.
 */
const OutOfScopeUids = ({ label, groups }: Props) => (
  <section aria-label={label} className="px-m py-s border-top">
    <Text.BodyText5 tag="p" bold color="grey70" className="mb-xs">
      {label}
    </Text.BodyText5>
    <ul className="list-unstyled m-0">
      {groups.map(group => (
        <li key={group.id} className="py-xxs grey-50">
          <PickerRowLabel row={group} />
        </li>
      ))}
    </ul>
  </section>
)

export default OutOfScopeUids
